export const SET_PLANT_DETAILS = 'SET_PLANT_DETAILS';
export const GET_GEN_CAPACITY_ALL = 'GET_GEN_CAPACITY_ALL';
export const GET_GEN_CAPACITY_EDIT_HISTORY = 'GET_GEN_CAPACITY_EDIT_HISTORY'
export const RESET_GEN_CAPACITY = 'RESET_GEN_CAPACITY'




